export default __webpack_public_path__ + "static/media/bathroom-Up_D112H213.a7afbe0c.jpg";